var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var velocity = require("velocity-animate");

function ShowMore( el ) {
    var t = this;
    t.$el = $( el );
    t.$parent = t.$el.parent();
    t.$content = t.$parent.siblings(".more-content");
    t.$hideButton = t.$content.find(".js-more-hide");
    // if ( t.$parent.length && t.$content.length ) {
        t.$el.on("click", function( e ) {
            e.preventDefault();
            t.$content.slideToggle("fast");
            t.$el.velocity("fadeOut", { duration: 300 });
        });
    // }
    // if ( t.$hideButton.length ) {
        t.$hideButton.on("click", function( e ) {
            e.preventDefault();
            t.$content.slideToggle("fast");
            t.$el.velocity("fadeIn", { duration: 300 });
        });
    // }
}

module.exports = ShowMore;